import React from "react";

export default React.createContext({
  items: [],
  categories: [],
  filterByCategory: category => {}
});
